module.exports = __webpack_public_path__ + "static/media/Icon-Money.3377b831.png";